import KTWizard from '../../../../theme/_assets/js/wizard';
import React, { Component } from "react";
import { Button,Card,Breadcrumb,Form,Table,ButtonGroup,ButtonToolbar } from "react-bootstrap";
import Select from 'react-select';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import SimpleReactValidator from 'simple-react-validator';
import { toast } from 'react-toastify';
import { Col, CardBody } from "reactstrap";
import { connect } from "react-redux";

var CryptoJS = require("crypto-js");
let key = process.env.REACT_APP_CRYPTO_KEY
var wizard = null;

class Firebasesetting extends Component {

  constructor(props) {
    super(props);
    this.state = {
		customerType: "",
		customerCode: "",
		parentList: [],
		childList: [],
		parentid: "",
		childid: "",
		note: "",
		disableChild: "",
		minimumLetterNote: "",
		powerBackupDeviceId: "",
		customerCode1:"",
		"webapikey":"", "serverapikey":""
		
	};
    this.validator = new SimpleReactValidator({ autoForceUpdate: this, className: 'text-danger' });
	this.handleUserFormFields = this.handleUserFormFields.bind(this);
  }

  modalToggle = () => {
    this.setState({ showModal: !this.state.showModal });
  }
  
   nextPath(path) {
    this.props.history.push({ pathname: path });
  }
  
 

  componentDidMount() {
	  
	  

	
	const urls = process.env.REACT_APP_NODE_ENV + "/api/configsetting/firebasesettingfetch";
    fetch(urls,{
      method:'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
      }
    }).then(
      response => {
        return response.json();
      }
    ).then(data => {
	   if(data.firebase[0]) {
       this.setState({ 
	    
				webapikey : data.firebase[0].webapikey,
				serverapikey :data.firebase[0].serverapikey,
				
		 })
	   }
	   else {
		   
		   this.setState({ 
	    
				webapikey : "",
				serverapikey : "",
				
		 })
	   }
    })
	
	
	
  }
 

handleUserFormFields = event => {
	
		switch (event.target.id) {
			case "uwebapikey":
				this.setState({ webapikey: event.target.value });
				break;
			case "userverapikey":
				this.setState({ serverapikey: event.target.value });
				break;
			
			
			default:
				break;
		}
	};

 handleEditFormFields = (event) => { 
    this.setState({ childid : event.target.value })
  }
  


  

	
  createConfiguration = () => {
	 
	 
	
			var postCustData = {
				"webapikey" : this.state.webapikey,
				"serverapikey":this.state.serverapikey,
				
				 
				};
	
		 
	  
		 
			fetch(process.env.REACT_APP_NODE_ENV + '/api/configsetting/firebasesettingcreate', {
			  method: 'POST',
			  headers: {
				'Content-Type': 'application/json',
				'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
			  },
			  body: JSON.stringify(postCustData)
			}).then((res) => res.json())
			  .then((data) => {
				
				toast.success("Firebase setting  added Successfully!!!", {
				  position: toast.POSITION.TOP_CENTER,
				});
				this.componentDidMount();
			}).catch((err) => console.log(err))
		
	
  }

  

  render() {
	 const customerType = this.state.customerType;
	let parentList = this.state.parentList.map(data => (
        <option key={data.id} value={data.id}>{data.parent_category}</option>
      ))
	
	  
	
		let customerTypeData = [
      { id: "customerType", label: "Apartment Customer", value: "Apartment_Customer" },
           { id: "customerType", label: "Individual Customer", value: "Individual_Customer" },
      { id: "customerType", label: "Corporate Customer", value: "Corporate_Customer" }]
	  
		
	
	  
	let customerData1 = [];
    if (customerType === "Apartment_Customer") {
		if(this.state.apartmentUserInput){
		  this.state.apartmentUserInput.map(data => {
			let sddData = { id: "customerCode", label: data.apartmentName+" ("+data.apartmentId+")", value: data.apartmentId }
			customerData1.push(sddData)
			return null;
		  })
		}
    } else if (customerType === "Corporate_Customer") {
		if(this.state.corporateUserInput){
		  this.state.corporateUserInput.map(data => {
			let sddData = { id: "customerCode", label: data.companyName+" ("+data.corporateId+")", value: data.corporateId }
			customerData1.push(sddData)
			return null;
		  })
		}
    } else if (customerType === "Individual_Customer") {
		if(this.state.individualUserInput){
		  this.state.individualUserInput.map(data => {
			let sddData = { id: "customerCode", label: data.name+" ("+data.individualId+")", value: data.individualId }
			customerData1.push(sddData)
			return null;
		  })
		}
    }
	
    return (<>
      <Breadcrumb>
        <Breadcrumb.Item
          onClick={() => this.nextPath("/config-setting/configuration")}
        >
         Setting 
          </Breadcrumb.Item>

        <Breadcrumb.Item active>Firebase Setting</Breadcrumb.Item>
      </Breadcrumb>
      <div>
        <Modal isOpen={this.state.modal} style={{ width: "1000px", display: "block" }}>
          <Card >
            <Card.Body>
              <ModalHeader>
                Add User
                </ModalHeader>
              <ModalBody>
              </ModalBody>
              <ModalFooter><div className="col-8 float-center">
                <Button variant="outline-primary" onClick={this.userSubmit}> Save </Button>
                &nbsp;&nbsp;&nbsp;
                <Button variant="outline-danger" onClick={this.userToggle}> Cancel </Button>
              </div>
              </ModalFooter>
            </Card.Body>
          </Card>
        </Modal>
      </div>
      <div>
      </div>

      <div ref={this.KTWizard} className="kt-grid kt-wizard-v1 kt-wizard-v1--white" id="kt_wizard_v1" data-ktwizard-state="step-first">
        <div className="kt-grid__item kt-grid__item--fluid kt-wizard-v1__wrapper">
          <form className="kt-form" id="kt_form" >
            <div className="kt-wizard-v1__content" data-ktwizard-type="step-content" data-ktwizard-state="current">
				<div className="kt-heading kt-heading--md">Firebase Setting</div>
				<div className="kt-form__section kt-form__section--first">
					<div className="kt-wizard-v1__form ">
					  <fieldset style={{ border: "1px solid #c7b6b6", }}>
						<legend style={{ width: "revert", fontSize :12, fontWeight:600 }}>Firebase Setting</legend>
						  
							<div className="form-group row"> 
							  <label className="col-lg-3 col-form-label text-lg-right">Web Api key:</label>
								<div className="col-lg-8 col-xl-8">
									 <input type="text" className="form-control" id="uwebapikey" value={this.state.webapikey}  onChange={this.handleUserFormFields}/>
									
								</div>
							</div>
							<div className="form-group row">   
							  <label className="col-lg-3 col-form-label text-lg-right">Server Api key:</label>
								<div className="col-lg-8 col-xl-8">
									 <input type="text" className="form-control" id="userverapikey" value={this.state.serverapikey}   onChange={this.handleUserFormFields} />
									
								</div>
							</div>
						 
						</fieldset>
						
					</div>
				</div>
            </div>
			
            <div className="kt-form__actions" style={{float: "right"}}>
                <Button variant="outline-primary" onClick={() => this.createConfiguration()} style={{ margin: "0px 5px "}} > Save </Button>
                
            </div>

            {/* <!--end: Form Actions --> */}
          </form>

          {/* <!--end: Form Wizard Form--> */}
        </div>
      </div>
    </>
    );
  }
} 


const mapStateToProps = (state /*, ownProps*/) => {
  return {
    userRole: state.auth.user[0].userType,
    userId: state.auth.user[0].id
  }
}

export default connect(
  mapStateToProps,
  null
)(Firebasesetting)